import { render, staticRenderFns } from "./ValuePass.vue?vue&type=template&id=2f408737&"
import script from "./ValuePass.vue?vue&type=script&lang=js&"
export * from "./ValuePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports